<!--
  Menú full-screen estilo “ART STGO” sobre fondo negro.
  Recuerda reemplazar "src" de las imágenes por las URLs o paths correctos.
-->
<div
  class="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm p-4"
>
  <div
    class="p-6 relative flex w-full max-h-[90%] max-w-6xl flex-col overflow-auto rounded-2xl bg-black text-white shadow-xl"
  >
    <!-- 1) Header: Logo + Botón Cerrar -->
    <div class="flex items-center justify-between px-4">
      <!-- Logo ART STGO -->
      <div class="flex items-center">
        <!-- Sustituye esto por la URL de tu logo -->
        <img
          src="images/logo/art-stgo-logo-white.png"
          alt="ART STGO"
          class="h-20 w-auto"
        />
      </div>
      <!-- Botón cerrar -->
    </div>
    <div
      (click)="closeModal()"
      class="absolute right-4 top-4 p-2 items-center flex rounded-full text-white hover:bg-gray-300"
    >
      <mat-icon fontIcon="close"></mat-icon>
    </div>

    <!-- 2) Links de Navegación -->
    <nav class="flex flex-col items-start px-4 py-3 space-y-2">
      @for (item of menuItems; track $index) {
        @if (item && item.label) {
          <button
            type="button"
            class="px-4 py-2 transition-colors hover:rounded-full cursor-pointer"
            (click)="goto(item)"
            [ngClass]="{
              'bg-primary  text-black rounded-full':
                item?.path && router.isActive(item.path, item.exact || false),
            }"
          >
            {{ item.label }}
          </button>
        }
      }
      <!-- <a
        href="/artistas"
        class="text-2xl font-light tracking-wide hover:text-gray-300 transition"
        >ARTISTAS</a
      >
      <a
        href="/obras"
        class="text-2xl font-light tracking-wide hover:text-gray-300 transition"
        >OBRAS</a
      >
      <a
        href="/programacion"
        class="text-2xl font-light tracking-wide hover:text-gray-300 transition"
        >PROGRAMACIÓN</a
      >
      <a
        href="/perfil"
        class="text-2xl font-light tracking-wide hover:text-gray-300 transition"
        >PERFIL</a
      > -->
    </nav>

    <!-- 3) Espacio flexible para empujar el footer hacia abajo -->
    <div class="flex-1"></div>

    <!-- 4) Sponsors / Logos al pie -->
    <div class="px-8 pb-8 space-y-8">
      <!-- <div class="flex items-center justify-center space-x-12">
        <div class="flex flex-col items-center">
          <span class="text-sm text-gray-400">Presenta:</span>
          <img
            src="/path/to/nescafe-logo.png"
            alt="Nescafé"
            class="h-8 w-auto mt-1"
          />
        </div>
        <div class="flex flex-col items-center">
          <span class="text-sm text-gray-400">Invita:</span>
          <img
            src="/path/to/canadadry-logo.png"
            alt="Canada Dry"
            class="h-8 w-auto mt-1"
          />
        </div>
      </div> -->
    </div>
  </div>
</div>
